const DEFAULT_CDN_BASE = 'https://laboratory.img.itchichi.de';

export const envConfig = {
  cdnBase: DEFAULT_CDN_BASE,
};

export const { cdnBase } = envConfig;
